<template>
  <div class="col-sm-12 col-xl-6">
    <div class="card">
      <div class="card-header pb-0">
        <h3>Basic Tabs</h3>
      </div>
      <div class="card-body">
        <ul class="nav nav-tabs" id="myTab" role="tablist">
          <li class="nav-item"><a class="nav-link active" id="home-tab" data-bs-toggle="tab" href="#home" role="tab"
              aria-controls="home" aria-selected="true">Home</a></li>
          <li class="nav-item dropdown"><a class="nav-link dropdown-toggle bg-transparent border-none"
              :class="active ? 'active show' : ''" @click="isActive()" data-bs-toggle="dropdown" href="javascript:void(0)"
              role="button" aria-haspopup="true" aria-expanded="false">Dropdown</a>
            <div class="dropdown-menu" :class="active ? 'show' : ''"><a class="dropdown-item" id="profile-tab"
                data-bs-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false">Action</a><a
                class="dropdown-item" href="javascript:void(0)">Another action</a><a class="dropdown-item"
                href="javascript:void(0)">Something else here</a><a class="dropdown-item"
                href="javascript:void(0)">Separated link</a></div>
          </li>
          <li class="nav-item"><a class="nav-link" id="profile-tabs" data-bs-toggle="tab" href="#profile" role="tab"
              aria-controls="profile" aria-selected="false">Profile</a></li>
          <li class="nav-item"><a class="nav-link" id="contact-tab" data-bs-toggle="tab" href="#contact" role="tab"
              aria-controls="contact" aria-selected="false">Contact</a></li>
        </ul>
        <div class="tab-content" id="myTabContent">
          <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
            <p class="mb-0 m-t-30">{{ desc }}</p>
          </div>
          <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
            <p class="mb-0 m-t-30">{{ desc }}</p>
          </div>
          <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
            <p class="mb-0 m-t-30">{{ desc }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      active: false,
      desc: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum"
    }
  },
  methods: {
    isActive() {
      this.active = !this.active
    }
  }
}
</script>